import { autoinject } from "aurelia-dependency-injection";
import { useView } from "aurelia-framework";
import { activationStrategy } from "aurelia-router";
import { AlphaNumericSortHelper } from "../../../../../../../../helpers/alpha-numeric-sort-helper";
import { MepGetVesselGroupItemResponse } from "../../../../../../../../models/mep/mep.models";
import { NotificationClientService, NotificationType } from "../../../../../../../../services/basics/notification-client.service";
import { MepService } from "../../../../../../../../services/mep/mep.service";

@autoinject
@useView('views/pages/modules/mep/tabs/mep-home/tabs/mep-terminology/mep-terminology.html')
export class MepTerminology {

    portId: number;
    vesselTypeGroups: MepGetVesselGroupItemResponse[];
    isVesselTypesTerminologyLoading: boolean = false;

    public determineActivationStrategy() {
        return activationStrategy.replace;
    }

    constructor(private mepService: MepService, private notificationClientService: NotificationClientService) {
    }

    activate(param) {
        this.portId = param.portId;

        if (this.portId) {
            // Get last years vessel type groups
            this.loadVesselTypeGroups();
        }
    }

    loadVesselTypeGroups()
    {
        this.isVesselTypesTerminologyLoading = true;
        // Get last years vessel type groups
        this.mepService.getVesselTypeGroups(this.portId, null)
        .then(x => {
            this.isVesselTypesTerminologyLoading = false;
            if (!x.hasError) {
                this.vesselTypeGroups = x.items.sort((a,b) => AlphaNumericSortHelper.alphaNumericSort(a, b, 'vesselTypeGroupName'));
            } else {
                this.notificationClientService.show("MEP Error", "Error loading vessel type groups!", NotificationType.Error);
            }

        }).catch(() => {
            this.isVesselTypesTerminologyLoading = false;
            this.notificationClientService.show("MEP Error", "Error loading vessel type groups!", NotificationType.Error);
        });
    }

    refresh(data?: {portId: number})
    {
        if(data.portId && this.portId != data.portId)
        {
            this.portId = data.portId;
            this.loadVesselTypeGroups();
        }
    }
}